import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  RadioGroup as AriaRadioGroup,
  RadioGroupProps,
} from "react-aria-components";

import { sharedStyles } from "../../../styles";

export function _RadioGroup(props: RadioGroupProps) {
  const className = css(sharedStyles.field, styles.radioGroup);

  return <AriaRadioGroup {...mergeProps(props, { className })} />;
}

const styles = {
  radioGroup: css({ gap: "var(--space-2)" }),
};
